<template>

  <!-- Gallery Image Slide -->
  <q-carousel-slide
    :name="name"
    v-if="slide"
    class="gallery-image-slide"
    :class="{cover: slide.cover}"
    :img-src="getFileUrl(slide, 1900)">

    <gallery-slide-overlay
      :slide="slide"/>

  </q-carousel-slide>

</template>

<script>

  import GallerySlideOverlay from '@src/components/gallery/gallery-slide-overlay';

  export default {
    name: 'gallery-image-slide',
    components: {
      GallerySlideOverlay,
    },
    props: {
      name: {
        type: String,
        default: '',
      },
      slide: {
        type: Object,
        default: null,
      },
    },
  };

</script>

<style lang="scss">

  .gallery-image-slide {
    color: inherit;
    transform: scale(1.004);
    background-size: contain;
    background-repeat: no-repeat;

    &.cover {
      background-size: cover;
    }
  }

</style>
